import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Cinemablend: Site = {
  id: 'cinemablend',
  logo: 'svg/cinemablend.svg',
  label: 'Cinemablend',
  analyticsName: 'cinemablend',
  hostname: 'cinemablend.com',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, article a`,
};
